export const levelToSelector = {
  1: "secondarys",
  2: "tertiarys"
}

export const levelToNav = {
  1: "secondary-nav",
  2: "tertiary-nav",
}

export const levelToFrontmatterDescriptor = {
  1: "mySecondary",
  2: "myTertiary",
}

export const MENU_INDENTATION = 16;
